import gql from "graphql-tag";

export const listAccountMasterCustom = /* GraphQL */ `
  query ListAccountMaster {
    listAccountMaster {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccountBalance {
        AccountBalance
        __typename
      }
      __typename
    }
  }
`;

export const getCommonLisingQueries = gql`
  query GetMainDetails {
    ListUserPreference: listUserPreference {
      UserID
      AttributeTypeCD
      EnteredTimeStamp
      ExpiredTimeStamp
      AttributeValue
      AdditionalValue
      __typename
    }
    ListAllFinancialYears: listAllFinancialYears {
      FinancialYearID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      StartDate
      EndDate
      StartYear
      EndYear
      Comments
      UserID
      AliasName
      StatusCode
      StatusMessage
      FreezeStatus
      TransferDate
      FreezeDate
      __typename
    }
    ListUserCompanies: listUserCompanies {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      WebsiteURL
      CurrencyCD
      AccountInventoryFlag
      PANNumber
      TDSTCSNumber
      CINRegistrationNumber
      RegistrationType
      CompPercentage
      GSTRPeriod
      LUT
      LUTBondValidFrom
      EwayBillFlag
      GSTApplicableFrom
      ThresholdLimitCD
      ThresholdLimitAmount
      CompanyShort
      LUTBondToDate
      InvoiceDetailApplicableFromDate
      TDSApplicable
      GSTCategory
      FinancialYearStartAndEndMonth
      CompanyLogoUrl
      MSMEType
      UdhyamRegNo
      UdhyamDocs
      EwayBillStartDate
      MinAmountEwayInter
      MinAmountEwayIntra
      EInvoiceFlag
      EInvoiceStartingDate
      GSTCompensationCessFlag
      TradeLicenseNumber
      TradeLicenseStartDate
      TradeLicenseEndDate
      LastUpdatedBy
      CINRegistrationDate
      EInvoiceConnect
      StatusCode
      StatusMessage
      BusinessType {
        BusinessTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        BusinessType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      IndustryType {
        IndustryTypeID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        IndustryType
        LastUpdatedBy
        Restrictedflag
        IsActive
        __typename
      }
      ActiveFlag
      RelatedFinancialYearData {
        FinancialYearID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        StartDate
        EndDate
        StartYear
        EndYear
        Comments
        UserID
        AliasName
        StatusCode
        StatusMessage
        FreezeStatus
        TransferDate
        FreezeDate
        __typename
      }
      __typename
    }
    ListAccountGroupMaster: listAccountGroupMaster {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      __typename
    }
    GetCompany: getCompany {
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      CompanyName
      StatusCode
      StatusMessage
      relatedCompanyDetailsNew {
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        WebsiteURL
        CurrencyCD
        AccountInventoryFlag
        PANNumber
        TDSTCSNumber
        CINRegistrationNumber
        RegistrationType
        CompPercentage
        GSTRPeriod
        LUT
        LUTBondValidFrom
        EwayBillFlag
        GSTApplicableFrom
        ThresholdLimitCD
        ThresholdLimitAmount
        CompanyShort
        LUTBondToDate
        InvoiceDetailApplicableFromDate
        TDSApplicable
        GSTCategory
        FinancialYearStartAndEndMonth
        CompanyLogoUrl
        MSMEType
        UdhyamRegNo
        UdhyamDocs
        EwayBillStartDate
        MinAmountEwayInter
        MinAmountEwayIntra
        EInvoiceFlag
        EInvoiceStartingDate
        GSTCompensationCessFlag
        TradeLicenseNumber
        TradeLicenseStartDate
        TradeLicenseEndDate
        LastUpdatedBy
        CINRegistrationDate
        EInvoiceConnect
        StatusCode
        StatusMessage
        BusinessType {
          BusinessTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          BusinessType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        IndustryType {
          IndustryTypeID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          IndustryType
          LastUpdatedBy
          Restrictedflag
          IsActive
          __typename
        }
        ActiveFlag
        RelatedFinancialYearData {
          FinancialYearID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          StartDate
          EndDate
          StartYear
          EndYear
          Comments
          UserID
          AliasName
          StatusCode
          StatusMessage
          FreezeStatus
          TransferDate
          FreezeDate
          __typename
        }
        __typename
      }
      relatedCompanyEntity {
        ID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        LegalName
        GSTIN
        FinancialYearCode
        CompanyEntityType
        StartDate
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedEmailContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        EmailAddress
        VerifiedDateTime
        PromotionsSignup
        StatusCode
        StatusMessage
        LastUpdatedBy
        __typename
      }
      relatedPhoneContacts {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        CountryCode
        PhoneNumber
        VerifiedDateTime
        PromotionsSignup
        SMSAllowed
        CallAllowed
        WhatsappAllowed
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      relatedAddressEntity {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      LastUpdatedBy
      AddressEntityID
      ObjectType
      Line1
      Line2
      Line3
      City
      StateCode
      StateName
      PINCode
      CountryCode
      District
      FinancialYearID
      EInvoiceUserName
      __typename
    }
  }
`;

export const listGeneralSettingV2 = /* GraphQL */ `
  query ListGeneralSetting(
    $EntryTypeCD1: String!
    $EntryTypeCD2: String!
    $EntryTypeCD3: String!
    $EntryTypeCD4: String!
    $EntryTypeCD5: String!
    $EntryTypeCD6: String!
    $EntryTypeCD7: String!
    $EntryTypeCD8: String!
    $EntryTypeCD9: String!
    $EntryTypeCD10: String!
    $FinancialYearID: Int
  ) {
    goods: listGeneralSetting(
      EntryTypeCD: $EntryTypeCD1
      FinancialYearID: $FinancialYearID
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
    service: listGeneralSetting(
      EntryTypeCD: $EntryTypeCD2
      FinancialYearID: $FinancialYearID
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
    sales: listGeneralSetting(
      EntryTypeCD: $EntryTypeCD3
      FinancialYearID: $FinancialYearID
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
    purchase: listGeneralSetting(
      EntryTypeCD: $EntryTypeCD4
      FinancialYearID: $FinancialYearID
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
    pos: listGeneralSetting(
      EntryTypeCD: $EntryTypeCD5
      FinancialYearID: $FinancialYearID
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
    journal: listGeneralSetting(
      EntryTypeCD: $EntryTypeCD6
      FinancialYearID: $FinancialYearID
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
    payment: listGeneralSetting(
      EntryTypeCD: $EntryTypeCD7
      FinancialYearID: $FinancialYearID
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
    receipt: listGeneralSetting(
      EntryTypeCD: $EntryTypeCD8
      FinancialYearID: $FinancialYearID
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
    credit: listGeneralSetting(
      EntryTypeCD: $EntryTypeCD9
      FinancialYearID: $FinancialYearID
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
    debit: listGeneralSetting(
      EntryTypeCD: $EntryTypeCD10
      FinancialYearID: $FinancialYearID
    ) {
      ID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      FinancialYearID
      EntryTypeCD
      SerialNumber
      SerialIsActive
      SerialIsUsed
      NextInvoiceNumber
      Prefix
      Suffix
      LastUpdatedBy
      StatusCode
      StatusMessage
      __typename
    }
  }
`;

export const getPartyDetailsv2 = gql`
  query GetPartyDetails(
    $PartyID: Int!
    $ObjectType: String!
    $ObjectID: String!
  ) {
    partyMaster: getPartyMaster(PartyID: $PartyID) {
      PartyID
      CompanyID
      CompanyBranchID
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
    }
    partyAddressEntity: getPartyAddressEntity(
      ObjectType: $ObjectType
      ObjectID: $ObjectID
    ) {
      ID
      ObjectType
      ObjectID
      Line1
      Line2
      Line3
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
    }
  }
`;

export const getPartyMasterSupplier = gql`
  query GetPartyDetails(
    $PartyID: Int!
    $ObjectType1: String!
    $ObjectType2: String!
    $ObjectType3: String!
    $ObjectType4: String!
    $ObjectID: String!
    $AccountGroupID: Int!
    $AccountGroupSubID: Int!
  ) {
    partyMaster: getPartyMaster(PartyID: $PartyID) {
      PartyID
      CompanyID
      CompanyBranchID
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      AccountTypeFlag
      StatusCode
      StatusMessage
      relatedPartyGstDetails {
        PartyID
        PANNummber
        GSTIN
        PartyAddressID
      }
      relatedPartyCreditDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        CreditPeriodDuration
        BillingCurrency
        CreditLimitCd
        CreditLimitAmount
        BillWiseFlag
        Notes
      }
      relatedPartyContact {
        PartyID
        ContactTypeName
        ContactDesignationName
        ContactOrder
        Email
        PhoneNumber
        WhatsappNumber
      }
      relatedPartyImages {
        AttachmentID
        PartyID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        Type
        DocumentName
        ImageName
        ImageURL
      }
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      Comments
      TDSSection
      __typename
    }
    partyBilling: getPartyAddressEntity(
      ObjectType: $ObjectType1
      ObjectID: $ObjectID
    ) {
      ID
      ObjectType
      ObjectID
      Line1
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
    }
    partyDelivery: getPartyAddressEntity(
      ObjectType: $ObjectType2
      ObjectID: $ObjectID
    ) {
      ID
      ObjectType
      ObjectID
      Line1
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
    }
    accountGroup: getAccountGroupMaster(AccountGroupID: $AccountGroupID) {
      AccountGroupID
      CompanyID
      CompanyBranchID
      AccountGroupName
      AccountParentGroupID
    }
    subGroup: listaccountsubgroups(AccountGroupID: $AccountGroupSubID) {
      AccountGroupID
      CompanyID
      CompanyBranchID
      AccountGroupName
      AccountParentGroupID
    }
    bankData: getBankDetails(ObjectID: $ObjectID, ObjectType: $ObjectType3) {
      BankDetailsID
      CompanyID
      CompanyBranchID
      ObjectID
      UserID
      BankName
      BankAccountNumber
      IFSCCode
      Branch
      Notes
      LedgerAccount
      BankAccountType
      Cash
      SwiftCode
    }
    tds: getCompanyCodeTranslation(CodeType: $ObjectType4) {
      ID
      CompanyID
      CodeType
      CodeValue
      CodeText
      CodeOrder
      UQC
      Is_Active
    }
  }
`;
export const getCompanyV2 = gql`
  query ListCompanyDocuments(
    $DocumentType: String!
    $PartyID: Int!
    $StartDate: Int!
    $EndDate: Int!
  ) {
    documents: listCompanyDocuments(
      DocumentType: $DocumentType
      PartyID: $PartyID
    ) {
      ID
      CompanyID
      PartyID
      DocumentType
      EnteredTimeStamp
      ExpiredTimeStamp
      ImageName
      ImageURL
      LastUpdatedBy
      IsActive
      Type
      DocumentName
      __typename
    }
    businessTypes: listBusinessType {
      BusinessTypeID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      BusinessType
      LastUpdatedBy
      Restrictedflag
      IsActive
      __typename
    }
    industryTypes: listIndustryType {
      IndustryTypeID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      IndustryType
      LastUpdatedBy
      Restrictedflag
      IsActive
      __typename
    }
    count: listDayBookTransactionsCount(
      StartDate: $StartDate
      EndDate: $EndDate
    ) {
      TransactionCount
      __typename
    }
    lut: listLUTBondMaster {
      ID
      LUTNo
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ValidFrom
      ValidTo
      FinancialYearID
      __typename
    }
  }
`;
export const getPartyMasterCust = gql`
  query GetPartyDetails(
    $PartyID: Int!
    $ObjectType1: String!
    $ObjectType2: String!
    $ObjectID: String!
    $AccountGroupID: Int!
    $AccountGroupSubID: Int!
  ) {
    partyMaster: getPartyMaster(PartyID: $PartyID) {
      PartyID
      CompanyID
      CompanyBranchID
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      SameAddressFlag
      AccountTypeFlag
      StatusCode
      StatusMessage
      relatedPartyGstDetails {
        PartyID
        PANNummber
        GSTIN
        PartyAddressID
      }
      relatedPartyCreditDetails {
        PartyID
        EnteredTimeStamp
        ExpiredTimeStamp
        CreditPeriodDuration
        BillingCurrency
        CreditLimitCd
        CreditLimitAmount
        BillWiseFlag
        Notes
      }
      relatedPartyContact {
        PartyID
        ContactTypeName
        ContactDesignationName
        ContactOrder
        Email
        PhoneNumber
        WhatsappNumber
      }
      relatedPartyImages {
        AttachmentID
        PartyID
        CompanyID
        EnteredTimeStamp
        ExpiredTimeStamp
        Type
        DocumentName
        ImageName
        ImageURL
      }
      LastUpdatedBy
      TDSPercentage
      UdhyamRegNo
      SameAddressFlag
      Comments
      TDSSection
      __typename
    }
    partyBilling: getPartyAddressEntity(
      ObjectType: $ObjectType1
      ObjectID: $ObjectID
    ) {
      ID
      ObjectType
      ObjectID
      Line1
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
    }
    partyDelivery: getPartyAddressEntity(
      ObjectType: $ObjectType2
      ObjectID: $ObjectID
    ) {
      ID
      ObjectType
      ObjectID
      Line1
      City
      StateCode
      StatusCode
      StatusMessage
      PINCode
      CountryCode
      District
      LastUpdatedBy
    }
    accountGroup: getAccountGroupMaster(AccountGroupID: $AccountGroupID) {
      AccountGroupID
      CompanyID
      CompanyBranchID
      AccountGroupName
      AccountParentGroupID
    }
    subGroup: listaccountsubgroups(AccountGroupID: $AccountGroupSubID) {
      AccountGroupID
      CompanyID
      CompanyBranchID
      AccountGroupName
      AccountParentGroupID
    }
  }
`;
export const getPartyAccountData = gql`
  query GetPartyDetails(
    $accountgroupid: Int!
    $accountgroupsubid: Int!
    $objecttype1: String!
  ) {
    accountGroup: getAccountGroupMaster(accountgroupid: $accountgroupid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
    subGroup: listaccountsubgroups(accountgroupid: $accountgroupsubid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
    tds: getCompanyCodeTranslation(codetype: $objecttype1) {
      id
      companyid
      codetype
      codevalue
      codetext
      codeorder
      uqc
      is_active
    }
  }
`;
export const getPartyAccountData1 = gql`
  query GetPartyDetails($accountgroupid: Int!, $accountgroupsubid: Int!) {
    accountGroup: getAccountGroupMaster(accountgroupid: $accountgroupid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
    subGroup: listaccountsubgroups(accountgroupid: $accountgroupsubid) {
      accountgroupid
      companyid
      companybranchid
      accountgroupname
      accountparentgroupid
    }
  }
`;
export const listAccountMasterFlatCustom = /* GraphQL */ `
  query ListAccountMaster {
    listAccountMaster {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      __typename
    }
  }
`;

export const getInvoiceMaster = /* GraphQL */ `
  query GetInvoiceMaster($InvoiceID: Int!) {
    getInvoiceMaster(InvoiceID: $InvoiceID) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTCSDetails {
        InvoiceID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TCSApplicableCD
        TotalTaxableAmount
        IneligibleTCFlag
        ReverseChargeFlag
        GSTCessTotal
        TCSAmount
        AdjustmentAmount
        TCSSection
        LastUpdatedBy
        StatusCode
        StatusMessage
        TCSPercentage
        TCSManual
        __typename
      }
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
        RelatedInvoiceLineGST {
          InvoiceID
          InvoiceItemID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          GSTRate
          GSTTypeCD
          GSTAmount
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedItemMaster {
          ItemID
          ItemCode
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ItemName
          SalesInvoiceFlag
          PurchaseInvoiceFlag
          ItemCategoryCD
          MeasurementCD
          CurrencyCD
          SalesAccountID
          PurchaseAccountID
          TaxabilityCD
          ReverseChargeFlag
          ItemType
          HSNID
          Is_Active
          StatusCode
          StatusMessage
          relatedItemAmountDetails {
            ItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            Amount
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTCompensationValue
            GSTRATE
            StatusCode
            StatusMessage
            LastUpdatedBy
            DiscountType
            DiscountValue
            InvoiceType
            PriceType
            IsActive
            IsDefault
            __typename
          }
          relatedItemGstDetails {
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            HSNID
            GSTCessType
            GSTCompensationValue
            EffectiveDate
            ExpiredDate
            GSTCessValue
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          relatedItemImages {
            AttachmentID
            ItemID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            ImageName
            ImageURL
            DocumentName
            Type
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          SerialNumber
          HSNSACID
          HSNCodeType
          HSNCodeValue
          HSNDescription
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        PriceType
        LotID
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        Unit
        __typename
      }
      RelatedInvoiceLineNonItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        InvoiceLineItemType
        IncomeAccountID
        HSNSACCode
        Taxability
        ItemDescription
        TaxableAmount
        NetAmount
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
          RelatedAccountGSTDetails {
            AccountID
            CompanyID
            EnteredTimeStamp
            ExpiredTimeStamp
            EffectiveDate
            ExpiredDate
            HSNID
            GSTCompensationType
            GSTRate
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountOpeningBalance {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            FinancialYearID
            StartDate
            CreditAmount
            DebitAmount
            StatusCode
            StatusMessage
            __typename
          }
          RelatedAccountGroupMaster {
            AccountGroupID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountTypeCD
            AccountGroupName
            AccountParentGroupID
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Is_Active
            Restrictedflag
            __typename
          }
          RelatedAccountBalance {
            AccountBalance
            __typename
          }
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        HSNSACID
        HSNCodeType
        HSNCodeValue
        HSNDescription
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        __typename
      }
      RelatedInvoiceAttachment {
        InvoiceID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        StatusCode
        StatusMessage
        DocumentName
        Type
        __typename
      }
      RelatedInvoiceDispatch {
        InvoiceID
        DispatchID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransportationCD
        VehicleNumber
        DispatchDate
        EWayBillNumber
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoicePOSDetails {
        POSID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyPOSID
        LastUpdatedBy
        RelatedPOSParty {
          PosPartyID
          CompanyID
          PartyName
          PartyContactNumberID
          LastUpdatedBy
          EnteredTimeStamp
          ExpiredTimeStamp
          RelatedPhoneContacts {
            ID
            ObjectType
            ObjectID
            EnteredTimeStamp
            ExpiredTimeStamp
            CountryCode
            PhoneNumber
            VerifiedDateTime
            PromotionsSignup
            SMSAllowed
            CallAllowed
            WhatsappAllowed
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          __typename
        }
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceLineNonGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
      RelatedInvoiceNumberTracker {
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        NextInvoiceNumber
        LastUpdatedBy
        __typename
      }
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
          RelatedAccounts {
            AccountsID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AccountName
            AccountTypeCD
            AccountGroupID
            HSNSACCode
            DisplayOrderNumber
            StatusCode
            StatusMessage
            Restrictedflag
            Is_Active
            AccountTypeFlag
            RelatedAccountGSTDetails {
              AccountID
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              EffectiveDate
              ExpiredDate
              HSNID
              GSTCompensationType
              GSTRate
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountOpeningBalance {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              FinancialYearID
              StartDate
              CreditAmount
              DebitAmount
              StatusCode
              StatusMessage
              __typename
            }
            RelatedAccountGroupMaster {
              AccountGroupID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountTypeCD
              AccountGroupName
              AccountParentGroupID
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Is_Active
              Restrictedflag
              __typename
            }
            RelatedAccountBalance {
              AccountBalance
              __typename
            }
            __typename
          }
          LastUpdatedBy
          StatusCode
          StatusMessage
          FinancialYearID
          __typename
        }
        RelatedTransactionAttachment {
          TransactionID
          AttachmentID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AttachmentName
          AttachmentURL
          LastUpdatedBy
          DocumentName
          StatusCode
          StatusMessage
          Type
          __typename
        }
        RelatedTransactionTDSDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TDSApplicableCD
          TDSAmount
          TDSManual
          LastUpdatedBy
          StatusCode
          StatusMessage
          TDSPercentage
          __typename
        }
        RelatedPurchaseMaster {
          PurchaseID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          PurchaseGSTTypeCD
          SupplierID
          EntryDate
          VoucherNumber
          SupplierInvoiceDate
          SupplierInvoiceNumber
          SupplierAddressID
          PaymentTypeCD
          PaidAmount
          CreditDuration
          PaymentAccountID
          Comments
          TDSApplicableFlag
          GrantTotalAmount
          BalanceDueAmount
          PaymentClearedFlag
          PlaceOfSupply
          CompanyState
          RelatedPurchaseTDSDetails {
            PurchaseID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TDSApplicableCD
            TotalTaxableAmount
            IneligibleTCFlag
            ReverseChargeFlag
            GSTCessTotal
            TDSAmount
            AdjustmentAmount
            TDSSection
            TDSPercentage
            TDSManual
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseLineItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            ItemNumber
            ItemID
            PurchaseAccountID
            HSNCode
            ItemQuantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNSACCode
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            Unit
            __typename
          }
          RelatedPurchaseLineNonItems {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PurchaseLineItemType
            PurchaseAccountID
            HSNSACCode
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedPurchaseLineGST {
              PurchaseID
              PurchaseItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              CessAmount
              GSTAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            Taxability
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTAmount
            CessAmount
            __typename
          }
          RelatedPurchaseLineGST {
            PurchaseID
            PurchaseItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            CessAmount
            GSTAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedPurchaseAttachment {
            PurchaseID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedPurchaseTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          RelatedPurchaseTransactionRelation {
            TransactionID
            TransactionTypeCD
            ObjectType
            ObjectID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LinkedAmount
            ObjectAttribute
            IsDirect
            LastUpdatedBy
            AccountID
            PaymentVoucherNumber
            StatusCode
            StatusMessage
            __typename
          }
          LastUpdatedBy
          CancelFlag
          RoundOffAmount
          DiscountType
          DiscountValue
          AdjustmentAmount
          SerialNumber
          CurrencyCode
          CurrencyRate
          ReverseChargeFlag
          PaymentStatus
          PartyRegistrationType
          __typename
        }
        RelatedInvoiceMaster {
          InvoiceID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          InvoiceTypeCD
          PartyID
          PaymentAccountID
          InvoiceDate
          InvoiceNumber
          CustomerOrderNumber
          CustomerOrderDate
          InvoiceAmount
          PaymentType
          CreditDuration
          InvoiceBillingAddressID
          InvoiceDeliveryAddressID
          InvoiceTaxableTypeCD
          ReceiptURL
          InvoiceLineTypeCD
          InvoiceCurrencyCD
          ExchangeRate
          Comments
          ReceivedAmount
          AdjustmentAmount
          PlaceOfSupply
          BalanceDueAmount
          ReverseChargeFlag
          TCSApplicableFlag
          RelatedInvoiceLineItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            LineItemNumber
            InvoiceLineItemType
            ItemID
            Quantity
            UnitTypeCD
            ItemRate
            ItemAmount
            ItemDiscount
            NetAmount
            HSNSACCode
            Taxability
            RelatedInvoiceLineGST {
              InvoiceID
              InvoiceItemID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              GSTRate
              GSTTypeCD
              GSTAmount
              CessAmount
              LastUpdatedBy
              StatusCode
              StatusMessage
              __typename
            }
            RelatedItemMaster {
              ItemID
              ItemCode
              CompanyID
              EnteredTimeStamp
              ExpiredTimeStamp
              ItemName
              SalesInvoiceFlag
              PurchaseInvoiceFlag
              ItemCategoryCD
              MeasurementCD
              CurrencyCD
              SalesAccountID
              PurchaseAccountID
              TaxabilityCD
              ReverseChargeFlag
              ItemType
              HSNID
              Is_Active
              StatusCode
              StatusMessage
              relatedItemAmountDetails {
                ItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                Amount
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTCompensationValue
                GSTRATE
                StatusCode
                StatusMessage
                LastUpdatedBy
                DiscountType
                DiscountValue
                InvoiceType
                PriceType
                IsActive
                IsDefault
                __typename
              }
              relatedItemGstDetails {
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                HSNID
                GSTCessType
                GSTCompensationValue
                EffectiveDate
                ExpiredDate
                GSTCessValue
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              relatedItemImages {
                AttachmentID
                ItemID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                ImageName
                ImageURL
                DocumentName
                Type
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              SerialNumber
              HSNSACID
              HSNCodeType
              HSNCodeValue
              HSNDescription
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            PriceType
            LotID
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            Unit
            __typename
          }
          RelatedInvoiceLineNonItems {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            InvoiceLineItemType
            IncomeAccountID
            HSNSACCode
            Taxability
            ItemDescription
            TaxableAmount
            NetAmount
            RelatedAccounts {
              AccountsID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AccountName
              AccountTypeCD
              AccountGroupID
              HSNSACCode
              DisplayOrderNumber
              StatusCode
              StatusMessage
              Restrictedflag
              Is_Active
              AccountTypeFlag
              RelatedAccountGSTDetails {
                AccountID
                CompanyID
                EnteredTimeStamp
                ExpiredTimeStamp
                EffectiveDate
                ExpiredDate
                HSNID
                GSTCompensationType
                GSTRate
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountOpeningBalance {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                FinancialYearID
                StartDate
                CreditAmount
                DebitAmount
                StatusCode
                StatusMessage
                __typename
              }
              RelatedAccountGroupMaster {
                AccountGroupID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountTypeCD
                AccountGroupName
                AccountParentGroupID
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Is_Active
                Restrictedflag
                __typename
              }
              RelatedAccountBalance {
                AccountBalance
                __typename
              }
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            HSNSACID
            HSNCodeType
            HSNCodeValue
            HSNDescription
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            __typename
          }
          RelatedInvoiceAttachment {
            InvoiceID
            AttachmentID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            AttachmentName
            AttachmentURL
            LastUpdatedBy
            StatusCode
            StatusMessage
            DocumentName
            Type
            __typename
          }
          RelatedInvoiceDispatch {
            InvoiceID
            DispatchID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransportationCD
            VehicleNumber
            DispatchDate
            EWayBillNumber
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoicePOSDetails {
            POSID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            PartyPOSID
            LastUpdatedBy
            RelatedPOSParty {
              PosPartyID
              CompanyID
              PartyName
              PartyContactNumberID
              LastUpdatedBy
              EnteredTimeStamp
              ExpiredTimeStamp
              RelatedPhoneContacts {
                ID
                ObjectType
                ObjectID
                EnteredTimeStamp
                ExpiredTimeStamp
                CountryCode
                PhoneNumber
                VerifiedDateTime
                PromotionsSignup
                SMSAllowed
                CallAllowed
                WhatsappAllowed
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              __typename
            }
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceLineGST {
            InvoiceID
            InvoiceItemID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            GSTRate
            GSTTypeCD
            GSTAmount
            CessAmount
            LastUpdatedBy
            StatusCode
            StatusMessage
            __typename
          }
          RelatedInvoiceNumberTracker {
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            NextInvoiceNumber
            LastUpdatedBy
            __typename
          }
          RelatedInvoiceTransactionDetails {
            TransactionID
            CompanyID
            CompanyBranchID
            EnteredTimeStamp
            ExpiredTimeStamp
            TransactionTypeCD
            VoucherNumber
            EntryDate
            BankReferenceNumber
            Comments
            RelatedTransactionDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TransactionTypeCD
              AccountID
              CreditAmount
              DebitAmount
              Comments
              EntryOrderNumber
              TransactionBalance
              OpeningBalance
              RelatedAccounts {
                AccountsID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AccountName
                AccountTypeCD
                AccountGroupID
                HSNSACCode
                DisplayOrderNumber
                StatusCode
                StatusMessage
                Restrictedflag
                Is_Active
                AccountTypeFlag
                __typename
              }
              LastUpdatedBy
              StatusCode
              StatusMessage
              FinancialYearID
              __typename
            }
            RelatedTransactionAttachment {
              TransactionID
              AttachmentID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              AttachmentName
              AttachmentURL
              LastUpdatedBy
              DocumentName
              StatusCode
              StatusMessage
              Type
              __typename
            }
            RelatedTransactionTDSDetails {
              TransactionID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              TDSApplicableCD
              TDSAmount
              TDSManual
              LastUpdatedBy
              StatusCode
              StatusMessage
              TDSPercentage
              __typename
            }
            RelatedPurchaseMaster {
              PurchaseID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              PurchaseGSTTypeCD
              SupplierID
              EntryDate
              VoucherNumber
              SupplierInvoiceDate
              SupplierInvoiceNumber
              SupplierAddressID
              PaymentTypeCD
              PaidAmount
              CreditDuration
              PaymentAccountID
              Comments
              TDSApplicableFlag
              GrantTotalAmount
              BalanceDueAmount
              PaymentClearedFlag
              PlaceOfSupply
              CompanyState
              RelatedPurchaseTDSDetails {
                PurchaseID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TDSApplicableCD
                TotalTaxableAmount
                IneligibleTCFlag
                ReverseChargeFlag
                GSTCessTotal
                TDSAmount
                AdjustmentAmount
                TDSSection
                TDSPercentage
                TDSManual
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseLineItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                ItemNumber
                ItemID
                PurchaseAccountID
                HSNCode
                ItemQuantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNSACCode
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                Unit
                __typename
              }
              RelatedPurchaseLineNonItems {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PurchaseLineItemType
                PurchaseAccountID
                HSNSACCode
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                Taxability
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTAmount
                CessAmount
                __typename
              }
              RelatedPurchaseLineGST {
                PurchaseID
                PurchaseItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                CessAmount
                GSTAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedPurchaseAttachment {
                PurchaseID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedPurchaseTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              RelatedPurchaseTransactionRelation {
                TransactionID
                TransactionTypeCD
                ObjectType
                ObjectID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LinkedAmount
                ObjectAttribute
                IsDirect
                LastUpdatedBy
                AccountID
                PaymentVoucherNumber
                StatusCode
                StatusMessage
                __typename
              }
              LastUpdatedBy
              CancelFlag
              RoundOffAmount
              DiscountType
              DiscountValue
              AdjustmentAmount
              SerialNumber
              CurrencyCode
              CurrencyRate
              ReverseChargeFlag
              PaymentStatus
              PartyRegistrationType
              __typename
            }
            RelatedInvoiceMaster {
              InvoiceID
              CompanyID
              CompanyBranchID
              EnteredTimeStamp
              ExpiredTimeStamp
              InvoiceTypeCD
              PartyID
              PaymentAccountID
              InvoiceDate
              InvoiceNumber
              CustomerOrderNumber
              CustomerOrderDate
              InvoiceAmount
              PaymentType
              CreditDuration
              InvoiceBillingAddressID
              InvoiceDeliveryAddressID
              InvoiceTaxableTypeCD
              ReceiptURL
              InvoiceLineTypeCD
              InvoiceCurrencyCD
              ExchangeRate
              Comments
              ReceivedAmount
              AdjustmentAmount
              PlaceOfSupply
              BalanceDueAmount
              ReverseChargeFlag
              TCSApplicableFlag
              RelatedInvoiceLineItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                LineItemNumber
                InvoiceLineItemType
                ItemID
                Quantity
                UnitTypeCD
                ItemRate
                ItemAmount
                ItemDiscount
                NetAmount
                HSNSACCode
                Taxability
                LastUpdatedBy
                StatusCode
                StatusMessage
                PriceType
                LotID
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                Unit
                __typename
              }
              RelatedInvoiceLineNonItems {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                InvoiceLineItemType
                IncomeAccountID
                HSNSACCode
                Taxability
                ItemDescription
                TaxableAmount
                NetAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                HSNSACID
                HSNCodeType
                HSNCodeValue
                HSNDescription
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                __typename
              }
              RelatedInvoiceAttachment {
                InvoiceID
                AttachmentID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                AttachmentName
                AttachmentURL
                LastUpdatedBy
                StatusCode
                StatusMessage
                DocumentName
                Type
                __typename
              }
              RelatedInvoiceDispatch {
                InvoiceID
                DispatchID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransportationCD
                VehicleNumber
                DispatchDate
                EWayBillNumber
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoicePOSDetails {
                POSID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                PartyPOSID
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceLineGST {
                InvoiceID
                InvoiceItemID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                GSTRate
                GSTTypeCD
                GSTAmount
                CessAmount
                LastUpdatedBy
                StatusCode
                StatusMessage
                __typename
              }
              RelatedInvoiceNumberTracker {
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                NextInvoiceNumber
                LastUpdatedBy
                __typename
              }
              RelatedInvoiceTransactionDetails {
                TransactionID
                CompanyID
                CompanyBranchID
                EnteredTimeStamp
                ExpiredTimeStamp
                TransactionTypeCD
                VoucherNumber
                EntryDate
                BankReferenceNumber
                Comments
                LastUpdatedBy
                StatusCode
                StatusMessage
                CancelFlag
                CancelRemark
                SerialNumber
                __typename
              }
              LastUpdatedBy
              CancelFlag
              StatusCode
              StatusMessage
              ConsigneeName
              ConsigneeGSTIN
              CompanyState
              CancelRemark
              DeleteRemark
              RoundOffAmount
              DiscountType
              DiscountValue
              SerialNumber
              CurrencyCode
              CurrencyRate
              PaymentStatus
              AckNo
              AckDt
              Irn
              SignedQRCode
              __typename
            }
            LastUpdatedBy
            StatusCode
            StatusMessage
            CancelFlag
            CancelRemark
            SerialNumber
            __typename
          }
          LastUpdatedBy
          CancelFlag
          StatusCode
          StatusMessage
          ConsigneeName
          ConsigneeGSTIN
          CompanyState
          CancelRemark
          DeleteRemark
          RoundOffAmount
          DiscountType
          DiscountValue
          SerialNumber
          CurrencyCode
          CurrencyRate
          PaymentStatus
          AckNo
          AckDt
          Irn
          SignedQRCode
          __typename
        }
        LastUpdatedBy
        StatusCode
        StatusMessage
        CancelFlag
        CancelRemark
        SerialNumber
        __typename
      }
      RelatedPartyMaster {
        PartyID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        ContactNumber
        WhatsappNumber
        AccountsID
        Is_Active
        MSMEType
        DeliveryConsigneeName
        DeliveryConsigneeGstin
        StatusCode
        StatusMessage
        relatedPartyGstDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          PANNummber
          GSTIN
          PartyAddressID
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyCreditDetails {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          CreditPeriodDuration
          BillingCurrency
          CreditLimitCd
          CreditLimitAmount
          BillWiseFlag
          Notes
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyContact {
          PartyID
          EnteredTimeStamp
          ExpiredTimeStamp
          ContactTypeName
          ContactDesignationName
          ContactOrder
          Email
          PhoneNumber
          WhatsappNumber
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        relatedPartyImages {
          AttachmentID
          PartyID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          Type
          DocumentName
          ImageName
          ImageURL
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        LastUpdatedBy
        TDSPercentage
        UdhyamRegNo
        SameAddressFlag
        Comments
        TDSSection
        __typename
      }
      RelatedPartyBillingAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPartyDeliveryAddressDetails {
        ID
        ObjectType
        ObjectID
        EnteredTimeStamp
        ExpiredTimeStamp
        Line1
        Line2
        Line3
        City
        StateCode
        StatusCode
        StatusMessage
        PINCode
        CountryCode
        District
        LastUpdatedBy
        __typename
      }
      RelatedPaymentAccountDetails {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
        AccountTypeFlag
        RelatedAccountGSTDetails {
          AccountID
          CompanyID
          EnteredTimeStamp
          ExpiredTimeStamp
          EffectiveDate
          ExpiredDate
          HSNID
          GSTCompensationType
          GSTRate
          CessAmount
          LastUpdatedBy
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountOpeningBalance {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          FinancialYearID
          StartDate
          CreditAmount
          DebitAmount
          StatusCode
          StatusMessage
          __typename
        }
        RelatedAccountGroupMaster {
          AccountGroupID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountTypeCD
          AccountGroupName
          AccountParentGroupID
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Is_Active
          Restrictedflag
          __typename
        }
        RelatedAccountBalance {
          AccountBalance
          __typename
        }
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      PaymentStatus
      AckNo
      AckDt
      Irn
      SignedQRCode
      __typename
    }
  }
`;

export const getBusinessOverViewDataCustom = /* GraphQL */ `
  query GetBusinessOverViewData(
    $businessOverViewInput: BusinessOverViewInput!
  ) {
    getBusinessOverViewData(businessOverViewInput: $businessOverViewInput) {
      StartDate
      EndDate
      AccountGroupName
      AccountTypeCD
      GroupBalance
      DataType
      __typename
    }
  }
`;

export const listAccountGroupMasterCustom = /* GraphQL */ `
  query ListAccountGroupMaster {
    listAccountGroupMaster {
      accountgroupid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accounttypecd
      accountgroupname
      accountparentgroupid
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
    }
  }
`;
export const listAccountGroupMasterCustom2 = /* GraphQL for items page, this includes relatedaccounts */ `
  query ListAccountGroupMaster {
    listAccountGroupMaster {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
      }
      __typename
    }
  }
`;
export const getAccountGroupMasterCustom = /* GraphQL */ `
  query GetAccountGroupMaster($AccountGroupID: Int!) {
    getAccountGroupMaster(AccountGroupID: $AccountGroupID) {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      __typename
    }
  }
`;

export const listInvoiceMasterCustomer = /* GraphQL */ `
  query ListInvoiceMastervr2 {
    listInvoiceMastervr2 {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      BalanceDueAmount
      __typename
    }
  }
`;

export const listPurchaseMasterSupplier = /* GraphQL */ `
  query ListPurchaseMasterv2 {
    listPurchaseMasterv2 {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      BalanceDueAmount
      __typename
    }
  }
`;
export const listInvoiceMasterCustom = /* GraphQL */ `
  query ListInvoiceMaster {
    listInvoiceMaster {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceLineItems {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        LineItemNumber
        InvoiceLineItemType
        ItemID
        Quantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        HSNSACCode
        Taxability
      }
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
    }
  }
`;

export const listInvoiceMasterCustomWithOutRelatedData = /* GraphQL */ `
  query ListInvoiceMaster {
    listInvoiceMaster {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
    }
  }
`;
export const listPurchaseMasterCustomWithOutRelated = /* GraphQL */ `
  query ListPurchaseMaster {
    listPurchaseMaster {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
    }
  }
`;
export const listPurchaseMasterCustom = /* GraphQL */ `
  query ListPurchaseMaster {
    listPurchaseMaster {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseLineItems {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        ItemNumber
        ItemID
        PurchaseAccountID
        HSNCode
        ItemQuantity
        UnitTypeCD
        ItemRate
        ItemAmount
        ItemDiscount
        NetAmount
        Taxability
      }
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
    }
  }
`;
export const listlatestInvoiceCustom = /* GraphQL */ `
  query ListlatestInvoice {
    listlatestInvoice {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
    }
  }
`;
export const listlatestPurchaseCustom = /* GraphQL */ `
  query ListlatestPurchase {
    listlatestPurchase {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
    }
  }
`;
export const listCrDrNoteMasterCustom = /* GraphQL */ `
  query ListCrDrNoteMaster {
    listCrDrNoteMaster {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      ReverseChargeFlag
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      PlaceOfSupply
      CancelFlag
      CancelRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      PartAmount
    }
  }
`;
export const listInvoiceLineItemsCustom = /* GraphQL */ `
  query ListInvoiceLineItems {
    listInvoiceLineItems {
      InvoiceID
      InvoiceItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      LineItemNumber
      InvoiceLineItemType
      ItemID
      Quantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      HSNSACCode
      Taxability
      RelatedInvoiceLineGST {
        InvoiceID
        InvoiceItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        GSTTypeCD
        GSTAmount
        CessAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
    }
  }
`;
export const listPurchaseLineItemsCustom = /* GraphQL */ `
  query ListPurchaseLineItems {
    listPurchaseLineItems {
      PurchaseID
      PurchaseItemID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemNumber
      ItemID
      PurchaseAccountID
      HSNCode
      ItemQuantity
      UnitTypeCD
      ItemRate
      ItemAmount
      ItemDiscount
      NetAmount
      RelatedPurchaseLineGST {
        PurchaseID
        PurchaseItemID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        GSTRate
        CessAmount
        GSTAmount
        LastUpdatedBy
        StatusCode
        StatusMessage
        __typename
      }
    
      
        LastUpdatedBy
        __typename
      }
      LastUpdatedBy
      StatusCode
      StatusMessage
      Taxability
      __typename
    }
  }
`;
export const listItemmastersCustom = /* GraphQL */ `
  query ListItemmasters {
    listItemmasters {
      ItemID
      ItemCode
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      ItemName
      SalesInvoiceFlag
      PurchaseInvoiceFlag
      ItemCategoryCD
      MeasurementCD
      CurrencyCD
      SalesAccountID
      PurchaseAccountID
      TaxabilityCD
      ReverseChargeFlag
      ItemType
      HSNID
      Is_Active
      StatusCode
      StatusMessage
    }
  }
`;

export const listInvoiceMasterv2Custom = /* GraphQL */ `
  query ListInvoiceMasterv2(
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listInvoiceMasterv2(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      AckNo
      AckDt
      Irn
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyAccountID
      AckNo
      AckDt
      Irn
      is_cancelled
      RelatedPartyMaster {
        PartyID
        PartyTypeCd
        PartyDisplayName
        PartyLegalName
        GroupAccountID
        GSTCategory
        PlaceOfSupply
        Entity
        Email
        relatedPartyGstDetails {
          PartyID

          GSTIN
        }
      }
    }
  }
`;
export const listInvoiceMasterv2ForListing = /* GraphQL */ `
  query ListInvoiceMasterv2(
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listInvoiceMasterv2(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyAccountID
      AckNo
      AckDt
      Irn
    }
  }
`;
export const listPurchaseMasterTestCustom = /* GraphQL */ `
  query ListPurchaseMasterTest(
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listPurchaseMasterTest(
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyAccountID
      __typename
    }
  }
`;
export const listPurchaseTransactionMasterCustom = /* GraphQL */ `
  query ListPurchaseMaster {
    listPurchaseMaster {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
      }
    }
  }
`;

export const listInvoiceTransactionMasterCustom = /* GraphQL */ `
  query ListInvoiceMaster {
    listInvoiceMaster {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      RelatedInvoiceTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
      }
    }
  }
`;
export const listCrDrNoteDetailsMasterCustom = /* GraphQL */ `
  query ListCrDrNoteMaster {
    listCrDrNoteMaster {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      ReverseChargeFlag
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      PlaceOfSupply
      CancelFlag
      CancelRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      RelatedCrDrNoteDetails {
        CrDrNoteID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TotalTaxableAmount
        TotalGST
        TotalGSTCess
        TotalAdjustments
        Comments
        AccountID
        PartAmount
        TransportationCD
        VehicleNumber
        DispatchDate
        EWAYBillNumber
        UserID
        StatusCode
        StatusMessage
        __typename
      }
    }
  }
`;
export const getTransactionMasterCustom = /* GraphQL */ `
  query GetTransactionMaster($TransactionID: Int!) {
    getTransactionMaster(TransactionID: $TransactionID) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
      }
    }
  }
`;
export const listAccountMasterWithBalance = /* GraphQL */ `
  query ListAccountMaster {
    listAccountMaster {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccountBalance {
        AccountBalance
        __typename
      }
    }
  }
`;
export const listAccountGroupMasterWithLedger = /* GraphQL */ `
  query ListAccountGroupMaster {
    listAccountGroupMaster {
      AccountGroupID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountTypeCD
      AccountGroupName
      AccountParentGroupID
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      RelatedAccounts {
        AccountsID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AccountName
        AccountTypeCD
        AccountGroupID
        HSNSACCode
        DisplayOrderNumber
        StatusCode
        StatusMessage
        Restrictedflag
        Is_Active
      }
    }
  }
`;

export const listCrDrNoteMasterv2Custom = /* GraphQL */ `
  query ListCrDrNoteMasterv2(
    $CrDrNoteTypeCD: String!
    $RowFrom: Int!
    $LimitNo: Int!
    $ColumnName: String
    $OrderType: String
    $SearchMode: Int
    $SearchArray: AWSJSON
  ) {
    listCrDrNoteMasterv2(
      CrDrNoteTypeCD: $CrDrNoteTypeCD
      RowFrom: $RowFrom
      LimitNo: $LimitNo
      ColumnName: $ColumnName
      OrderType: $OrderType
      SearchMode: $SearchMode
      SearchArray: $SearchArray
    ) {
      CrDrNoteID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      CrDrNoteTypeCD
      CrDrNoteDate
      CrDrNoteNumber
      InvoiceTypeCD
      GSTTypeCD
      PartyID
      DeliveryAddressID
      PaymentType
      GrandTotalAmount
      TransactionID
      UserID
      CreditDuration
      StatusCode
      StatusMessage
      PSFlag
      ReverseChargeFlag
      BalanceDueAmount
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      PlaceOfSupply
      CancelFlag
      CancelRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartAmount
      PartyAccountID
      PartyTypeCd
      PartyInvoiceNumber
      __typename
    }
  }
`;
export const listTransactionMasterCustom = /* GraphQL */ `
  query ListTransactionMaster {
    listTransactionMaster {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
    }
  }
`;
export const listTransactionManualJournalCustom = /* GraphQL */ `
  query ListTransactionManualJournal {
    listTransactionManualJournal {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      CancelFlag
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
      }
    }
  }
`;
export const listTransactionManualJournalWithVoucher = /* GraphQL */ `
  query ListTransactionManualJournal {
    listTransactionManualJournal {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
    }
  }
`;
export const createTransactionMasterCustom = /* GraphQL */ `
  mutation CreateTransactionMaster(
    $createTransactionMasterInput: CreateTransactionMasterInput!
  ) {
    createTransactionMaster(
      createTransactionMasterInput: $createTransactionMasterInput
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
    }
  }
`;
export const listTransactionPurchaseMaster = /* GraphQL */ `
  query ListPurchaseMaster {
    listPurchaseMaster {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      RelatedPurchaseTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        VoucherNumber
        EntryDate
        BankReferenceNumber
        Comments
        RelatedTransactionDetails {
          TransactionID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          TransactionTypeCD
          AccountID
          CreditAmount
          DebitAmount
          Comments
          EntryOrderNumber
          TransactionBalance
          OpeningBalance
        }
      }
    }
  }
`;
export const listPartymastersCustom = /* GraphQL */ `
  query ListPartymasters {
    listPartymasters {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      PartyLegalName
      GroupAccountID
      GSTCategory
      PlaceOfSupply
      Entity
      Email
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
    }
  }
`;
export const listPartyAndTransactionMastersCustomPyt = /* GraphQL */ `
  query ListPartyAndTransactionMasters {
    listPartymasters: listPartymasters {
      PartyID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      GroupAccountID
      GSTCategory
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
    }
    listTransactionMaster: listTransactionMaster {
      TransactionID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
    }
  }
`;

export const listPartyAndTransactionMastersCustomRec = /* GraphQL */ `
  query GetPartyAndTransactionData {
    listPartymasters: listPartymasters {
      PartyID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PartyTypeCd
      PartyDisplayName
      GroupAccountID
      GSTCategory
      Entity
      ContactNumber
      WhatsappNumber
      AccountsID
      Is_Active
      MSMEType
      DeliveryConsigneeName
      DeliveryConsigneeGstin
      StatusCode
      StatusMessage
    listTransactionMaster: listTransactionMaster {
      TransactionID
      CompanyID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
    }
  }
`;
export const listAccountMasterv2Custom = /* GraphQL */ `
  query listAccountMaster {
    listAccountMaster {
      accountsid
      companyid
      companybranchid
      enteredtimestamp
      expiredtimestamp
      accountname
      accounttypecd
      accountgroupid
      hsnsaccode
      displayordernumber
      statuscode
      statusmessage
      restrictedflag
      is_active
      accountgrouptypecd
      accountgroupname
      accounttypeflag
      partyid
      tdspercentage
      tdssection
      path
    }
  }
`;
export const listAccountMasterWithoutBalance = /* GraphQL */ `
  query ListAccountMaster {
    listAccountMaster {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag
      __typename
    }
  }
`;
export const getTransactionMasterManualJournal = /* GraphQL */ `
  query GetTransactionMaster($TransactionID: Int!) {
    getTransactionMaster(TransactionID: $TransactionID) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
      SerialNumber
      CancelFlag
      RelatedTransactionDetails {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
      }
      RelatedTransactionAttachment {
        TransactionID
        AttachmentID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        AttachmentName
        AttachmentURL
        LastUpdatedBy
        DocumentName
        Type
        StatusCode
        StatusMessage
        __typename
      }
    }
  }
`;
export const getTransactionMasterOnly = /* GraphQL */ `
  query GetTransactionMaster($TransactionID: Int!) {
    getTransactionMaster(TransactionID: $TransactionID) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      VoucherNumber
      EntryDate
      BankReferenceNumber
      Comments
    }
  }
`;
export const listAccountTransactionDetailsCustom = /* GraphQL */ `
  query ListAccountTransactionDetails(
    $AccountID: Int!
    $StartDate: Int!
    $EndDate: Int!
  ) {
    listAccountTransactionDetails(
      AccountID: $AccountID
      StartDate: $StartDate
      EndDate: $EndDate
    ) {
      TransactionID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      TransactionTypeCD
      AccountID
      CreditAmount
      DebitAmount
      Comments
      EntryOrderNumber
      TransactionBalance
      OpeningBalance
      RelatedAccountsTransaction {
        TransactionID
        CompanyID
        CompanyBranchID
        EnteredTimeStamp
        ExpiredTimeStamp
        TransactionTypeCD
        AccountID
        CreditAmount
        DebitAmount
        Comments
        EntryOrderNumber
        TransactionBalance
        OpeningBalance
        VoucherNumber
        TransactionMasterTypeCD
        RelatedAccounts {
          AccountsID
          CompanyID
          CompanyBranchID
          EnteredTimeStamp
          ExpiredTimeStamp
          AccountName
          AccountTypeCD
          AccountGroupID
          HSNSACCode
          DisplayOrderNumber
          StatusCode
          StatusMessage
          Restrictedflag
          Is_Active
          AccountTypeFlag
        }
      }
    }
  }
`;
export const listBankAccountsCustom = /* GraphQL */ `
  query ListBankAccounts {
    listBankAccounts {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag

      __typename
    }
  }
`;

export const listCashAccountsCustom = /* GraphQL */ `
  query ListCashAccounts {
    listCashAccounts {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      AccountTypeCD
      AccountGroupID
      HSNSACCode
      DisplayOrderNumber
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag
      __typename
    }
  }
`;
export const listOutstandingPurchaseMasterCustom = /* GraphQL */ `
  query ListOutstandingPurchaseMaster {
    listOutstandingPurchaseMaster {
      PurchaseID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      PurchaseGSTTypeCD
      SupplierID
      EntryDate
      VoucherNumber
      SupplierInvoiceDate
      SupplierInvoiceNumber
      SupplierAddressID
      PaymentTypeCD
      PaidAmount
      CreditDuration
      PaymentAccountID
      Comments
      TDSApplicableFlag
      GrantTotalAmount
      BalanceDueAmount
      PaymentClearedFlag
      PlaceOfSupply
      CompanyState
      LastUpdatedBy
      CancelFlag
      RoundOffAmount
      DiscountType
      DiscountValue
      AdjustmentAmount
      StatusCode
      StatusMessage
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyLegalName
      PartyAccountID
      __typename
    }
  }
`;
export const listOutstandingInvoiceMasterCustom = /* GraphQL */ `
  query ListOutstandingInvoiceMaster {
    listOutstandingInvoiceMaster {
      InvoiceID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      InvoiceTypeCD
      PartyID
      PaymentAccountID
      InvoiceDate
      InvoiceNumber
      CustomerOrderNumber
      CustomerOrderDate
      InvoiceAmount
      PaymentType
      CreditDuration
      InvoiceBillingAddressID
      InvoiceDeliveryAddressID
      InvoiceTaxableTypeCD
      ReceiptURL
      InvoiceLineTypeCD
      InvoiceCurrencyCD
      ExchangeRate
      Comments
      ReceivedAmount
      AdjustmentAmount
      PlaceOfSupply
      BalanceDueAmount
      ReverseChargeFlag
      TCSApplicableFlag
      LastUpdatedBy
      StatusCode
      StatusMessage
      CancelFlag
      ConsigneeName
      ConsigneeGSTIN
      CompanyState
      CancelRemark
      DeleteRemark
      RoundOffAmount
      DiscountType
      DiscountValue
      SerialNumber
      CurrencyCode
      CurrencyRate
      PartyDisplayName
      PartyAccountID
      __typename
    }
  }
`;

export const getPartyMasterAccountWiseCustom = /* GraphQL */ `
  query GetPartyMasterAccountWise($AccountsID: Int!) {
    getPartyMasterAccountWise(AccountsID: $AccountsID) {
      PartyID
      CompanyID
      PartyTypeCd
      AccountsID
      Is_Active
    }
  }
`;

export const getAccountMasterName = `
  query GetAccountMaster($AccountsID: Int!) {
    getAccountMaster(AccountsID: $AccountsID) {
      AccountsID
      CompanyID
      CompanyBranchID
      EnteredTimeStamp
      ExpiredTimeStamp
      AccountName
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountTypeFlag
    }
  }
`;

export const getCutomPartyMaster = /* GraphQL */ `
  query GetPartyMaster($PartyID: Int!) {
    getPartyMaster(PartyID: $PartyID) {
      PartyID
      Email
      PartyDisplayName
      AccountsID
      PartyLegalName
      EnteredTimeStamp
      PartyTypeCd
      GroupAccountID
      Comments
      ContactNumber
      DeliveryConsigneeGstin
      DeliveryConsigneeName
      Entity
      GSTCategory
      PlaceOfSupply
      Is_Active
      MSMEType
      WhatsappNumber
      SameAddressFlag
      TDSPercentage
      TDSSection
      UdhyamRegNo
    }
  }
`;
export const CustomListAccountMasterSearch = /* GraphQL */ `
  query ListAccountMasterSearch($Word: String!) {
    listAccountMasterSearch(Word: $Word) {
      AccountsID
      CompanyID
      CompanyBranchID
      AccountName
      AccountTypeCD
      AccountGroupID
      StatusCode
      StatusMessage
      Restrictedflag
      Is_Active
      AccountGroupName
      __typename
    }
  }
`;
